import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { MapContainer, Popup } from 'react-leaflet';
import L from 'leaflet';

import IsMobile from './components/IsMobile';
import IsTablet from './components/IsTablet';
import PopupCard from './components/PopupCard';
import PointerPodcast from './components/PointerPodcast';
import EventComponent from './components/EventComponent';
import Select from 'react-select';
import options from './db.json';

// Import du style
import './App.css';
import { Checkbox } from 'semantic-ui-react';

const PODCAST_ZOOM = 5;

function App() {
  //// Initialisation des states qui permettront l'affichage de la carte en fonction du dropdown /////////////
  const [checkedPodcast, setCheckedPodcast] = useState(['NATIF', 'RADIO']);
  const [selectedPodcast, setSelectedPodcast] = useState(null);
  const [potentialSelectedPodcast, setPotentialSelectedPodcast] =
    useState(null);
  const [map, setMap] = useState(null);
  const [markerSize, setMarkerSize] = useState(2);
  const [rc, setRc] = useState(null);

  const location = useLocation();
  const history = useHistory();

  ///////////////////// Rastercoord //////////////////////////////////////////////

  L.RasterCoords = require('leaflet-rastercoords');

  const img = [
    7200, // original width of image
    5059, // original height of image
  ];

  useEffect(() => {
    if (!map) return;
    // assign map and image dimensions
    const rc = new L.RasterCoords(map, img);
    setRc(rc);
    // set max zoom Level (might be `x` if gdal2tiles was called with `-z 0-x` option)
    map.setMaxZoom(5);
    map.setMinZoom(2);
    // all coordinates need to be unprojected using the `unproject` method
    // set the view in the lower right edge of the image
    map.setView(rc.unproject([img[0] / 2, 0]), 3);

    // the tile layer containing the image generated with `gdal2tiles --leaflet -p raster -w none <img> tiles`
    L.tileLayer('/tuiles/{z}/{x}/{y}.png', {
      noWrap: true,
    }).addTo(map);

    if (location.pathname === '/') {
      map.flyTo(
        rc.unproject([3470, 0]),
        3
      );
      return;
    };

    for (const podcast of options) {
      const slug = podcast.icon.replace('/icons/', '').replace('.png', '');
      if (location.pathname === '/' + slug) {
        setTimeout(() => {
          handleChange(podcast, map, rc);
        }, 400);
      }
    }
  }, [map]);

  /////// Fonction pour changer l'affichage /////////////////////////////////////

  const handleChange = (e, map, rc) => {
    if (map !== null && rc) {
      setSelectedPodcast(null);
      setPotentialSelectedPodcast(e.value);

      if (e.longitudePodcast <= 900) {
        map.flyTo(
          rc.unproject([e.latitudePodcast, e.longitudePodcast + 150]),
          PODCAST_ZOOM
        );
      } else {
        map.flyTo(
          rc.unproject([e.latitudePodcast, e.longitudePodcast - 150]),
          PODCAST_ZOOM
        );
      }
    }
  };

  //// Fonction pour filter les podcasts au click des checkbox /////////

  const handleChecked = (e, { value, checked }) => {
    const itemChecked = checkedPodcast.filter((item) => item !== value);
    if (checked) {
      itemChecked.push(value);
    }
    setCheckedPodcast(itemChecked);
  };

  ///// Gestion de l'url
  useEffect(() => {
    if (location.pathname === '/') return;
    for (const podcast of options) {
      const slug = podcast.icon.replace('/icons/', '').replace('.png', '');
      if (location.pathname === '/' + slug) {
        handleChange(podcast, map, rc);
      }
    }
  }, [location]);

  const customStyles = {
    option: (provided) => ({
      ...provided,
      fontSize: '0.75rem',
    }),
  };

  const customStyles2 = {
    option: (provided) => ({
      ...provided,
      fontSize: '1.25rem',
    }),
  };

  return (
    <div className="container-app">
      <div className="header">
        <div className="header-responsive">
          <a href="https://www.audiomeans.fr/" target="_blank" rel="noreferrer">
            {IsMobile(
              <img
                className="logo-responsive"
                src="./logo-responsive.png"
                alt="logo audiomeans"
              />,
              <img className="logo" src="./nlogow.png" alt="logo audiomeans" />
            )}
          </a>

          <div className="checkbox-container">
            <Checkbox
              className="checkbox"
              label={IsMobile('Natif', 'Podcast natif')}
              value="NATIF"
              checked={checkedPodcast.includes('NATIF')}
              onChange={handleChecked}
            />
            <Checkbox
              className="checkbox"
              label={IsMobile('Radio', 'Replay radio')}
              value="RADIO"
              checked={checkedPodcast.includes('RADIO')}
              onChange={handleChecked}
            />
            <Checkbox
              className="checkbox"
              label={IsMobile('1000+', '1000+ notes')}
              value="MILLE"
              checked={checkedPodcast.includes('MILLE')}
              onChange={handleChecked}
            />
          </div>
        </div>
        <Select
          isSearchable={true}
          isClearable={true}
          placeholder={IsMobile('Podcast', 'Sélectionnez un podcast')}
          className="dropdown"
          options={options}
          styles={IsMobile(customStyles, customStyles2)}
          onChange={(e) => {
            if (e) {
              const slug = e.icon.replace('/icons/', '').replace('.png', '');
              history.push(slug);
            } else {
              history.push('/');
              map.flyTo(rc.unproject([img[0] / 2, 0]), 3);
              setSelectedPodcast(null);
            }
          }}
        />
      </div>
      <MapContainer
        eventHandlers={{
          movestart: (e) => {
            e.target.closePopup();
          },

          dragstart: (e) => {
            e.target.closePopup();
          },
        }}
        closePopupOnClick={true}
        id="map"
        whenCreated={(map) => {
          setMap(map);
        }}
        zoomControl={(IsMobile(true, false), IsTablet(true, false))}
        tap={false}
      >
        <EventComponent
          setMarkerSize={setMarkerSize}
          setSelectedPodcast={setSelectedPodcast}
          potentialSelectedPodcast={potentialSelectedPodcast}
          setPotentialSelectedPodcast={setPotentialSelectedPodcast}
        />
        {rc &&
          options
            .sort((a, b) => a.label.localeCompare(b.label))
            .filter(
              (podcast) =>
                checkedPodcast.includes(podcast.type) &&
                (!checkedPodcast.includes('MILLE') || podcast.notes >= 1000)
            )
            .map((podcast, i) => (
              <PointerPodcast
                key={i}
                selected={selectedPodcast === podcast.value}
                podcast={podcast}
                coords={rc.unproject([
                  podcast.latitudePodcast,
                  podcast.longitudePodcast,
                ])}
                markerSize={markerSize}
              >
                <Popup autoClose={true} closeOnClick={true}>
                  <PopupCard
                    cover={podcast.cover}
                    type={podcast.type}
                    namePodcast={podcast.label}
                    authorPodcast={podcast.authorPodcast}
                    pitchPodcast={podcast.pitchPodcast}
                    icon={podcast.icon}
                    website={podcast.website}
                  />
                </Popup>
              </PointerPodcast>
            ))}
      </MapContainer>
      <div className="footer-container">
        <p className="footer-content">
          <a
            href="https://www.audiomeans.fr/post/podcast-city-une-ville-foisonnante-au-creux-de-loreille"
            target="_blank"
            rel="noreferrer"
          >
            Pour en savoir plus sur Podcast City, c'est ici
          </a>
        </p>
      </div>
    </div>
  );
}

export default App;
